const DND_INVARIANT_PREFIX = "Invariant failed";

/**
 * Sentry beforeSend filter for react-beautiful-dnd's invariant errors.
 *
 * The library throws a plain object (not an Error) with message "Invariant failed" when a drag ends
 * in an unexpected state, then catches it itself, aborts the drag, and recovers. Sentry's wrapped
 * event listeners report it first, which is all HERO-BUILDER-CLIENT-JG is.
 *
 * @param {object} event
 * @param {object} hint
 * @returns {object|null} null to drop the event
 */
export function dropRecoveredDndInvariant(event, hint) {
  const original = hint?.originalException;

  if (
    original &&
    typeof original === "object" &&
    !(original instanceof Error) &&
    typeof original.message === "string" &&
    original.message.startsWith(DND_INVARIANT_PREFIX)
  )
    return null;

  return event;
}

export default dropRecoveredDndInvariant;
